import { DialogContent, DialogOverlay } from '@reach/dialog';
import { AnimatePresence, motion } from 'framer-motion';
import { memo } from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onDismiss: () => void;
  ariaLabel: string;
  bypassScrollLock?: boolean;
  bypassFocusLock?: boolean;
  allowPinchZoom?: boolean;
  forwardSx?: ThemeUIStyleObject;
  closeButtonColor?: string | null;
};

const AnimatedModal = ({
  children,
  isOpen,
  onDismiss,
  ariaLabel,
  bypassScrollLock,
  bypassFocusLock,
  forwardSx,
  closeButtonColor,
  allowPinchZoom,
}: Props) => {
  const MotionDialogOverlay = motion(DialogOverlay);

  return (
    <AnimatePresence>
      {isOpen && (
        <MotionDialogOverlay
          key="modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          sx={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          }}
          dangerouslyBypassScrollLock={bypassScrollLock}
          dangerouslyBypassFocusLock={bypassFocusLock}
          onDismiss={onDismiss}
          allowPinchZoom={allowPinchZoom}
        >
          <DialogContent
            aria-label={ariaLabel}
            sx={{
              '--strokecolor': ['black', closeButtonColor ?? 'black'],
              '--backgroundcolor': 'white',
              width: 'fit-content',
              maxWidth: ['88.5%', '100%'],
              mx: [0, '3rem'],
              backgroundColor: 'var(--backgroundcolor)',
              overflow: 'hidden',
              position: 'relative',
              ...forwardSx,
            }}
          >
            {children}
          </DialogContent>
        </MotionDialogOverlay>
      )}
    </AnimatePresence>
  );
};

export default memo(AnimatedModal);
